import { onBeforeUnmount, ref, } from 'vue';
import { WefatComponentRuntimeError } from './component-error.js';
function milliseconds(value, fallback, property) {
    const parsed = value === undefined ? fallback : Number(value);
    if (!Number.isFinite(parsed) || parsed < 0) {
        throw new WefatComponentRuntimeError('WF5002', `${property} requires a finite non-negative number of milliseconds`, `Set ${property} to zero or a positive number.`);
    }
    return parsed;
}
export function resolveWefatHoverTiming(input) {
    return Object.freeze({
        startTime: milliseconds(input.hoverStartTime, 50, 'hover-start-time'),
        stayTime: milliseconds(input.hoverStayTime, 400, 'hover-stay-time'),
    });
}
export function useWefatHoverState(input) {
    const active = ref(false);
    let startTimer = null;
    let stayTimer = null;
    function clearStartTimer() {
        if (startTimer !== null)
            clearTimeout(startTimer);
        startTimer = null;
    }
    function clearStayTimer() {
        if (stayTimer !== null)
            clearTimeout(stayTimer);
        stayTimer = null;
    }
    function cancel() {
        clearStartTimer();
        clearStayTimer();
        active.value = false;
    }
    function onPointerdown() {
        const timing = resolveWefatHoverTiming(input);
        clearStartTimer();
        clearStayTimer();
        if (timing.startTime === 0) {
            active.value = true;
            return;
        }
        startTimer = setTimeout(() => {
            startTimer = null;
            active.value = true;
        }, timing.startTime);
    }
    function onPointerup() {
        const timing = resolveWefatHoverTiming(input);
        clearStartTimer();
        clearStayTimer();
        if (!active.value || timing.stayTime === 0) {
            active.value = false;
            return;
        }
        stayTimer = setTimeout(() => {
            stayTimer = null;
            active.value = false;
        }, timing.stayTime);
    }
    onBeforeUnmount(cancel);
    return Object.freeze({
        active,
        onPointercancel: cancel,
        onPointerdown,
        onPointerleave: cancel,
        onPointerup,
    });
}
//# sourceMappingURL=hover-state.js.map